import * as React from "react";
import { SVGAttributes } from "react";

export const MegaphoneIcon = React.memo(
  ({
    size = 24,
    color = "#4E5361",
    ...props
  }: SVGAttributes<SVGElement> & {
    size?: number,
  }) => {
    return (
      <svg width={size} height={size} fill="none" {...props}>
        <path
          d="M44.357 21.522L26.272 3.437a4.8 4.8 0 00-6.782 0 4.794 4.794 0 00-.584 6.075l-.025.126A33.461 33.461 0 019.7 26.79l-8.295 8.295a4.793 4.793 0 000 6.781l4.52 4.522a4.793 4.793 0 006.783 0l1.13-1.13 7.912 7.911a4.793 4.793 0 006.782 0 4.8 4.8 0 000-6.781l-3.391-3.391 1.13-1.13a4.793 4.793 0 000-6.782l-.768-.768a33.465 33.465 0 0112.653-5.405l.128-.025a4.801 4.801 0 006.072-.584 4.801 4.801 0 000-6.782zM10.448 44.128a1.598 1.598 0 01-2.26 0l-4.522-4.521a1.598 1.598 0 010-2.26l7.912-7.913 6.782 6.782-7.912 7.912zm15.824 4.521a1.6 1.6 0 010 2.26 1.6 1.6 0 01-2.26 0l-7.913-7.911 2.261-2.261 7.912 7.912zm-5.651-10.173c.48-.48 1.2-1.216 2.335-2.186l1.056 1.056a1.597 1.597 0 010 2.26l-1.13 1.131-2.261-2.26zm.068-4.453l-6.918-6.918a36.605 36.605 0 007.782-14.823l13.96 13.959a36.603 36.603 0 00-14.824 7.782zm21.407-7.98a1.598 1.598 0 01-2.26 0L21.75 7.958a1.597 1.597 0 112.26-2.26l18.085 18.085a1.6 1.6 0 010 2.26z"
          fill="#9B53C8"
        />
        <path
          d="M12.707 35.088a1.598 1.598 0 00-2.26 0l-2.26 2.26a1.599 1.599 0 002.26 2.26l2.26-2.26a1.598 1.598 0 000-2.26zM33.613 0a1.6 1.6 0 00-1.599 1.599v3.196a1.598 1.598 0 103.197 0V1.6c0-.884-.715-1.6-1.598-1.6zm12.79 12.787h-3.197a1.598 1.598 0 100 3.197h3.197a1.599 1.599 0 000-3.197zm-2.066-9.122a1.599 1.599 0 00-2.26 0L38.88 6.862a1.599 1.599 0 002.26 2.26l3.197-3.196a1.599 1.599 0 000-2.26z"
          fill="#9B53C8"
        />
      </svg>
    );
  }
);
